module.exports = __webpack_public_path__ + "static/media/amenities_2.2e6a2ec0.svg";